export abstract class ServerSentEvents {
  static readonly END_SESSION = 'EndSession';
}
